






import Vue from 'vue';
import ScoreBoard from './components/ScoreBoard.vue';

export default Vue.extend({
  name: 'app',
  components: {
    ScoreBoard
  }
});
